// Params here are always any as we can stringify any value
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stringCompare = (first: any, second: any): boolean =>
  JSON.stringify(first) === JSON.stringify(second);
